import React, { Suspense, lazy } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'

import AlertMessage from '../../components/AlertMessage'
import PageLoader from '../../components/PageLoader'
import ProjectDeck from './ProjectDeck'
import integrationsActions from '../../integrations/actions'

// Lazy load ReleaseNoteAnnouncer - it checks Rails env at render time
const ReleaseNoteAnnouncer = lazy(() => import('../../components/ReleaseNoteAnnouncer'))

class ProjectsPage extends React.Component {
  componentDidMount() {
    this.fetchIntegrationsIfNeeded()
  }

  componentDidUpdate() {
    this.fetchIntegrationsIfNeeded()
  }

  fetchIntegrationsIfNeeded() {
    const { dispatch, fetchingStatus, loggingStatus } = this.props

    if (fetchingStatus === 'idle') {
      dispatch(integrationsActions.fetchAll())
    }
    if (fetchingStatus === 'failed' && loggingStatus === 'succeeded') {
      dispatch(integrationsActions.fetchAll())
    }
  }

  render() {
    const {
      fetchingError,
      integrations,
      t
    } = this.props

    if (integrations === null) {
      return (
        <div className="d-flex flex-column flex-fill justify-content-center align-items-center">
          <PageLoader message={t('fetchingIntegration')} />
        </div>
      )
    }

    if (fetchingError) {
      return (
        <div className="d-flex flex-column flex-fill justify-content-center">
          <AlertMessage>
            {t('errors.somethingWentWrong', { ns: 'commons' })}
          </AlertMessage>
        </div>
      )
    }

    return (
      <div className="d-flex flex-column p-3" id="projects">
        <ProjectDeck />
        <Suspense fallback={null}>
          <ReleaseNoteAnnouncer />
        </Suspense>
      </div>
    )
  }
}

ProjectsPage.propTypes = {
  dispatch: PropTypes.func.isRequired,
  fetchingError: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object
  ]),
  fetchingStatus: PropTypes.string,
  integrations: PropTypes.arrayOf(PropTypes.object),
  loggingStatus: PropTypes.string,
  t: PropTypes.func.isRequired
}

ProjectsPage.defaultProps = {
  fetchingError: null,
  fetchingStatus: 'idle',
  integrations: null,
  loggingStatus: 'idle'
}

const mapStateToProps = ({
  authentication: {
    loggingStatus
  },
  integrations: {
    fetchingError,
    fetchingStatus,
    items: integrations
  }
}) => ({
  fetchingError,
  fetchingStatus,
  integrations,
  loggingStatus
})

export default withTranslation(['ProjectsPage', 'commons'])(
  connect(mapStateToProps)(ProjectsPage)
)
